import { FrameName } from "../config";
import AbstractPoiTileEntity from "./AbstractPoiTileEntity";

class ForestWhispering1PoiTileEntity extends AbstractPoiTileEntity {
	public static readonly frameName = FrameName.FOREST_WHISPERING1;
}

export default ForestWhispering1PoiTileEntity;
